// Module
var code = "<div class=\"panel panel-primary training\"> <div class=\"panel-heading\"> <h3 class=\"panel-title\">{{title}}</h3> </div> <div class=\"panel-body ng-scope\" id=\"trainingPanel\" style=\"\"> <training tabindexvalue=\"{{tabindexvalue}}\" isdcp=\"{{isdcp}}\" trainingtype=\"{{trainingtype}}\" count=\"{{count}}\"></training> </div> </div> ";
// Exports
export default code;